<template>
  <div class="yuyue-css">
    <el-image class="bglogo" :src="require('@/assets/eb/bgLogo.png')" />

    <el-image class="video-title" :src="require('@/assets/eb/title.png')" />
    <el-image
      v-if="!isH5"
      class="video-title video-title2"
      :src="require('@/assets/eb/title2.png')"
    />
    <el-image
      v-else
      class="video-title video-title2"
      :src="require('@/assets/eb/h5title2.png')"
    />
    <img
      class="video-play"
      :src="require('@/assets/eb/play.png')"
      @click="openVideo"
    />

    <!-- 视频遮罩层 -->
    <div class="video-overlay" v-if="showVideo" @click="closeVideo">
      <video
        ref="videoRef"
        class="video-player"
        :src="videoSrc"
        autoplay
        controls
        @click.stop
      ></video>
    </div>

    <!-- 预约数量展示 -->
    <div class="yuyue-count">
      <img class="count-bg" :src="require('@/assets/eb/coutbg.png')" />

      <div class="count-text">{{ yy_num }}</div>
    </div>
    <!-- 预约按钮 -->
    <img
      class="pre-btn"
      :src="
        booked
          ? require('@/assets/eb/preEnd.png')
          : require('@/assets/eb/buttonpre.png')
      "
      @click="handlePreBtnClick"
    />

    <!-- 弹窗 -->
    <div class="dialog-overlay" v-if="showDialog">
      <div class="dialog-box">
        <img
          class="dialog-close"
          :src="require('@/assets/eb/closebtn.png')"
          @click="closeDialog"
        />
        <input
          class="dialog-input"
          v-model="email"
          type="email"
          placeholder="Please enter your Email"
        />
        <img
          class="dialog-confirm"
          :src="require('@/assets/eb/confirmbtn.png')"
          @click="confirm"
        />
      </div>
    </div>
    <!-- 社区 -->
    <div class="community">
      <img
        class="community-icon"
        :src="require('@/assets/df/facebook.png')"
        @click="goCommunity('facebook')"
      />
      <img
        class="community-icon"
        :src="require('@/assets/df/discord.png')"
        @click="goCommunity('discord')"
      />
    </div>

    <!-- 页脚 -->
    <div class="pre-footer">
      <a type="text" class="ys" :href="$t(`Secret.src`)" target="blank">{{
        $t(`Nav.secret`)
      }}</a>
      <a type="text" class="ys" :href="$t(`Terms.src`)" target="blank">{{
        $t(`Nav.terms`)
      }}</a>
    </div>
  </div>
</template>

<script>
import { getDeviceId } from '@/utils/request'
import { ElMessage } from 'element-plus'
import md5 from 'js-md5'
import { getCurrentInstance, onMounted, onUnmounted, ref } from 'vue'

export default {
  name: `zbb`,
  setup() {
    const { proxy } = getCurrentInstance()

    const isH5 = ref(false)
    const mediaQuery = window.matchMedia('(max-width: 750px)')
    const onMediaChange = (e) => {
      isH5.value = e.matches
    }

    const yy_num = ref(0)
    // 初始化接口
    const initData = async () => {
      try {
        const res = await proxy.$axios.post(
          '/v3/Booking/initData?game_id=633a07f3c76e344b&channel_id=yy',
          { game_no: 201 },
        )
        yy_num.value = res.data.yy_number
      } catch (e) {
        console.error('initData error:', e)
      }
    }

    onMounted(() => {
      isH5.value = mediaQuery.matches
      mediaQuery.addEventListener('change', onMediaChange)
      initData()
      showBookingSuccess()
      document.addEventListener('visibilitychange', onVisibilityChange)
    })
    onUnmounted(() => {
      mediaQuery.removeEventListener('change', onMediaChange)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    })

    // 是否已预约
    const booked = ref(localStorage.getItem('eb_booked') === '1')

    // 设备判断
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)

    // 返回页面时弹出预约成功提示
    const showBookingSuccess = () => {
      if (localStorage.getItem('eb_booking_success') === '1') {
        localStorage.removeItem('eb_booking_success')
        ElMessage.success(proxy.$t('Booking.success'))
      }
    }

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        showBookingSuccess()
      }
    }

    const communityLinks = {
      facebook: 'https://www.facebook.com/profile.php?id=61589437860611',
      discord: 'https://discord.gg/5VdNtF2aBz',
      ios: '',
      android: '',
    }

    const goCommunity = (type) => {
      window.open(communityLinks[type], '_blank')
    }

    const showDialog = ref(false)
    const email = ref('')

    const showVideo = ref(false)
    const videoRef = ref(null)
    const videoSrc = require('@/assets/df/video.mp4')

    const openVideo = () => {
      showVideo.value = true
    }

    const closeVideo = () => {
      if (videoRef.value) {
        videoRef.value.pause()
        videoRef.value.currentTime = 0
      }
      showVideo.value = false
    }

    const openDialog = () => {
      showDialog.value = true
      email.value = ''
    }

    const closeDialog = () => {
      showDialog.value = false
    }

    // 已预约后按钮不可点击
    const handlePreBtnClick = () => {
      if (booked.value) {
        return
      }
      openDialog()
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    // 防抖，防止接口重复提交
    let confirmLock = false

    const confirm = async () => {
      if (confirmLock) {
        return
      }
      if (!email.value) {
        ElMessage.warning('Please enter your email')
        return
      }
      if (!emailRegex.test(email.value)) {
        ElMessage.warning('Please enter a valid email address')
        return
      }
      confirmLock = true
      const deviceId = getDeviceId()
      const sign = md5('201' + email.value + deviceId)
      try {
        const res = await proxy.$axios.post(
          '/v3/Booking/bookNow?game_id=633a07f3c76e344b&channel_id=yy',
          {
            game_no: 201,
            email: email.value,
            sign,
          },
        )
        if (res.code === 0) {
          // 记录已预约状态
          localStorage.setItem('eb_booked', '1')
          booked.value = true
          // 判断设备并跳转对应商店链接
          const link = isIOS ? communityLinks.ios : communityLinks.android
          if (link) {
            localStorage.setItem('eb_booking_success', '1')
            window.location.href = link
          } else {
            showDialog.value = false
            // 更新预定人数
            initData()
            ElMessage.success(proxy.$t('Booking.success'))
          }
        } else {
          ElMessage.error(res.message || 'Booking failed')
        }
      } catch (e) {
        console.error('bookNow error:', e)
        ElMessage.error('Booking failed')
      } finally {
        setTimeout(() => {
          confirmLock = false
        }, 1000)
      }
    }

    return {
      isH5,
      yy_num,
      booked,
      goCommunity,
      showDialog,
      email,
      openDialog,
      closeDialog,
      handlePreBtnClick,
      confirm,
      showVideo,
      videoRef,
      videoSrc,
      openVideo,
      closeVideo,
    }
  },
}
</script>
<style scoped lang="less">
@import '@/assets/css/yuyue.css';

.yuyue-css {
  background: url('../../../src/assets/eb/bg.jpg') no-repeat center center;
}
.bglogo {
  left: 75%;
  width: 20%;
}
.video-title {
  position: absolute;
  left: 3vw;
  top: 15vh;
  width: 30vw;
}
.video-play {
  position: absolute;
  left: 47.5vw;
  margin-left: 0;
  top: 30vh;
  width: 5%;
}
.video-title2 {
  left: 4vw;
  top: 42.5vh;
  width: 27vw;
}
.yuyue-count {
  left: 4.5vw;
  top: 60%;
}
.count-bg {
  width: 12vw;
}
.count-text {
  width: 100%;
  position: absolute;
  left: 0;
  top: 100%;
  font-size: 3vw;
  background: linear-gradient(to bottom, #ede3da, #dab088);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  text-align: left;
}
.pre-btn {
  bottom: 15%;
  left: 3vw;
  width: 20%;
}
.video-overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.video-player {
  height: 100%;
  max-width: 100%;
  outline: none;
}
.dialog-box {
  background: url('../../../src/assets/eb/dialogbg.png') no-repeat center center;
  background-size: 100% 100%;
}
.dialog-input {
  width: 75%;
  height: 4.5vw;
  border: none;
  outline: none;
  border-radius: 0;
  padding: 0 6%;
  font-size: 1vw;
  color: #fff;
  background: url('../../../src/assets/eb/inputbg.png') no-repeat center center;
  background-size: 100% 100%;
  margin-bottom: 1vw;
  margin-top: 1vw;
  box-sizing: border-box;
}
.dialog-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.dialog-close {
  position: absolute;
  top: 0.5vw;
  right: -3vw;
  width: 2.5vw;
  cursor: pointer;
}
.dialog-confirm {
  width: 17vw;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.dialog-confirm:hover {
  transform: scale(1.05);
}
@media screen and (max-width: 750px) {
  .yuyue-css {
    background: url('../../../src/assets/eb/h5bg.jpg') no-repeat center center;
    background-size: cover;
  }
  .bglogo {
    width: 2.5rem;
    top: 0.4rem;
    left: 0rem;
  }
  .video-title {
    top: 46%;
    left: 0.5rem;
    width: 6.5rem;
  }
  .video-play {
    position: absolute;
    left: 3.25rem;
    top: 30%;
    margin-left: 0;
    width: 1rem;
    cursor: pointer;
  }
  .video-title2 {
    left: 0.75rem;
    top: 67%;
    width: 6rem;
  }
  .yuyue-count {
    left: 2rem;
    top: 82%;
  }
  .count-bg {
    width: 3.5rem;
  }
  .count-text {
    width: 100%;
    left: 0;
    top: 100%;
    font-size: 0.5rem;
    text-align: center;
  }
  .pre-btn {
    top: 73%;
    left: 1rem;
    width: 5.5rem;
  }
  .community {
    bottom: auto;
    top: 0.5rem;
    right: 0.5rem;
    width: 1.3rem;
  }
  .community-icon {
    width: 0.6rem;
    margin: 0.1rem;
  }
  .dialog-input {
    width: 78%;
    height: 0.7rem;
    border-radius: 0;
    padding: 0 0.3rem;
    font-size: 0.24rem;
    margin-bottom: 0.1rem;
    margin-top: 0.5rem;
  }
  .dialog-close {
    top: 3.7rem;
    right: 2.7rem;
    width: 0.55rem;
  }
  .dialog-confirm {
    width: 2.4rem;
  }
  .video-player {
    height: 80%;
  }
}
</style>
